import styled from 'styled-components';

export const CarouselContainer = styled.div`
  background: white;
  padding: 0px;
  margin: 8px auto;
  max-width: 1400px;
  border: 1px solid #10b981;
  border-radius: 4px;
`;

export const SectionTitle = styled.h2`
  color: #10b981;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 6px 0;
`;

export const CarouselWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

export const CarouselTrack = styled.div`
  display: flex;
  transition: transform 0.4s ease-in-out;
  transform: translateX(-${props => props.offset * (100 / props.itemsPerView)}%);
  gap: 5px;

  .carousel-item {
    flex: 0 0 calc(${props => 100 / props.itemsPerView}% - ${props => (5 * (props.itemsPerView - 1)) / props.itemsPerView}px);
    min-width: 0;
  }

  @media (max-width: 600px) {
    gap: 4px;
  }
`;

export const CarouselButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${props => props.direction === 'left' ? 'left: 2px;' : 'right: 2px;'}
  background: white;
  color: #10b981;
  border: 1px solid #10b981;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 10;
  line-height: 1;
  padding-bottom: 1px;

  &:hover {
    background: #10b981;
    color: white;
    transform: translateY(-50%) scale(1.1);
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    font-size: 14px;
  }
`;
